import React, { lazy } from 'react';
import { ActivateKit, KitStep, KitStepProps } from './ActivateKit';
import type { FC } from 'react';
import { KitType } from '@repo/types';

const KitActivationStep = lazy(() => import('./steps/KitActivationStep'));
const MemberStep = lazy(() => import('./steps/MemberStep'));
const CollectSampleTutorialStep = lazy(
  () => import('./steps/CollectSampleTutorialStep'),
);
const SwabLoadGuideStep = lazy(() => import('./steps/SwabLoadGuideStep'));
const SampleDetailsStep = lazy(() => import('./steps/SampleDetailsStep'));
const PractitionerStep = lazy(() => import('./steps/PractitionerStep'));
const ResearchStep = lazy(() => import('./steps/ResearchStep'));
const VersionUpdateStep = lazy(() => import('./steps/VersionUpdateStep/VersionUpdateStep'));

export const registerKitSteps: readonly KitStep[] = [
  {
    id: 'kitActivationStep',
    Component: KitActivationStep as FC<KitStepProps>,
    stage: 'activate',
  },
  {
    id: 'memberStep',
    Component: MemberStep as FC<KitStepProps>,
    exactPath: true,
    stage: 'activate',
  },
  {
    id: 'collectSampleTutorialStep',
    Component: CollectSampleTutorialStep as FC<KitStepProps>,
    stage: 'collect',
    redesignOnly: true,
    hideIf: state => !!state.kit.partner_id,
  },
  {
    id: 'swabLoadGuideStep',
    Component: SwabLoadGuideStep as FC<KitStepProps>,
    stage: 'collect',
    redesignOnly: true,
    featureFlag: 'swab_instructions_activation_flow',
    hideIf: state =>
      !!state.kit.partner_id || state.kit.sampling_type === KitType.VAGINAL,
  },
  {
    id: 'sampleDetailsStep',
    Component: SampleDetailsStep as FC<KitStepProps>,
    stage: 'collect',
  },
  {
    id: 'practitionerStep',
    Component: PractitionerStep as FC<KitStepProps>,
    optional: true,
    stage: 'collect',
  },
  {
    id: 'versionUpdateStep',
    Component: VersionUpdateStep as FC<KitStepProps>,
    stage: 'collect',
  },
  {
    id: 'researchStep',
    Component: ResearchStep as FC<KitStepProps>,
    optional: true,
    stage: 'collect',
  },
] as const;

const KitActivationContainer = () => {
  // Pass the steps configuration down as a prop
  return <ActivateKit steps={registerKitSteps} />;
};

export default KitActivationContainer;
